import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import { validationSchema } from "./validationSchema";

export default function ChangePassword() {
  const [changePassword, setChangePassword] = useState({
    old_password: "",
    password: "",
    password_confirmation: "",
  });
  const [errors, setErrors] = useState([]);

  const textFieldErrors = (field) => errors.find((e) => e.name === field.key);
  const helperTextErrors = (field) =>
    errors.find((e) => e.name === field.key)
      ? errors.find((e) => e.name === field.key).message
      : "";

  const handleChange = (event) => {
    const { name, value } = event.target;
    setChangePassword({ ...changePassword, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors([]);

    validationSchema
      .validate(changePassword, { abortEarly: false })
      .then(() => {
        axios
          .post("profile/change-password", changePassword)
          .then(({ data }) => {
            toast.success(data.message);
            setChangePassword({
              old_password: "",
              password: "",
              password_confirmation: "",
            });
          })
          .catch(({ response }) => {
            const errors = Object.keys(response.data.errors);
            setErrors([
              ...errors,
              ...errors.map((e) => ({
                name: e,
                message: response.data.errors[e][0],
              })),
            ]);
          });
      })
      .catch((err) => {
        const errors = err.inner.map((e) => {
          return {
            name: e.path,
            message: e.message,
          };
        });
        setErrors(errors);
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <input type="text" name="username" autocomplete="username" hidden />
      {[
        { key: "old_password", label: "Old Password", autocomplete: "current-password" },
        { key: "password", label: "New Password", autocomplete: "new-password" },
        { key: "password_confirmation", label: "Confirm Password", autocomplete: "new-password" },
      ].map((field, index) => (
        <div key={index} className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">
            {field.label}
          </label>
          <div className="col-lg-9 col-xl-6">
            <div className="input-group input-group-lg input-group-solid">
              <input
                className={`form-control form-control-lg form-control-solid${
                  textFieldErrors(field) ? " is-invalid" : ""
                }`}
                type="password"
                value={changePassword[field.key]}
                name={field.key}
                onChange={handleChange}
                placeholder={field.label}
                autocomplete={field.autocomplete}
              />
            </div>
            {textFieldErrors(field) && (
              <div className="fv-plugins-message-container">
                <div
                  data-field={field.key}
                  data-validator={helperTextErrors(field)}
                  className="fv-help-block"
                >
                  {helperTextErrors(field)}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
      <div className="card-toolbar row">
        <label className="col-xl-3 col-lg-3 col-form-label"></label>
        <div className="col-lg-9 col-xl-6">
          <button onClick={handleSubmit} type="button" className="btn btn-primary-custom">
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
}
